<div class="bg-night border border-white/10 rounded-xl p-6 min-w-[360px] text-center">
  <div class="flex justify-center mb-4">
    <div class="w-16 h-16 rounded-full bg-neon/20 flex items-center justify-center">
      <span class="material-symbols-outlined text-neon text-3xl">system_update</span>
    </div>
  </div>

  <h2 class="text-xl font-semibold text-white mb-2">
    {{ 'errors.new_version_title' | translate }}
  </h2>

  <p class="text-white/60 mb-6 leading-relaxed">
    {{ 'errors.new_version_message' | translate }}
  </p>

  <div class="flex justify-center">
    <k-button
      variant="primary"
      (click)="onReload()">
      {{ 'errors.reload_page' | translate }}
    </k-button>
  </div>
</div>
